const EVENTS = {
  ACCORDION_OPEN: 'accordion:open',
}

class ImageAndAccordions extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  setupListeners () {
    super.setupListeners()

    this.onAccordionToggle = this.onAccordionToggle.bind(this)

    this.listeners.add(this, EVENTS.ACCORDION_OPEN, this.onAccordionToggle)
  }

  onAccordionToggle (e) {
    this.activeIndex = Number(e.target.dataset.index)
  }

  get activeIndex () {
    return Number(this.dataset.activeIndex) || 0
  }

  set activeIndex (val) {
    this.dataset.activeIndex = val.toString()

    this.els.media.elements.forEach(
      (el, index) => (el.dataset.active = (index === val).toString()),
    )
  }
}

if (!customElements.get('image-and-accordions')) {
  customElements.define('image-and-accordions', ImageAndAccordions)
}
